import { taskTypesStatusesSlice } from "./taskTypesStatusesSlice";
import * as actions from "./taskTypesStatusesActions";
import * as selectors from "./taskTypesStatusesSelectors";

export { actions };
export { selectors };
export default taskTypesStatusesSlice.reducer;